module.exports = require("core-js-pure/stable/object/entries");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js-stable/object/entries.js
// module id = FRTc
// module chunks = 0